"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = _interopRequireDefault(require("../../constants/colors"));

var _spacing = _interopRequireDefault(require("../../constants/spacing"));

var _vars = _interopRequireDefault(require("../../constants/vars"));

var _reactGa = require("react-ga");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\topacity: 0 !important;\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\twidth: 100%;\n\theight: 100%;\n\t&:hover {\n\t\tcursor: pointer;\n\t}\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n    display: inline-block;\n    position: relative;\n    background: ", "\n\tpadding: ", " ", ";\n\tmargin: 4px 0 0 ", ";\n\tcolor: ", ";\n\tfont-weight: ", ";\n\tborder: 2px solid ", ";\n\tborder-radius: 8rem;\n\ttext-align: center;\n\t&:hover {\n\t\tbackground: ", ";\n\t}\n\t@media (max-width: 768px) {\n\t\tflex: 1;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Option = _styledComponents.default.label(_templateObject(), function (props) {
  return props.selected ? _colors.default.primaryLighter : _colors.default.white;
}, _spacing.default.s1, _spacing.default.s2, _spacing.default.s1, _colors.default.primary, _vars.default.fontWeight, _colors.default.primaryLighter, _colors.default.primaryLighter);

Option.displayName = 'Option';

var Radio = _styledComponents.default.input(_templateObject2());

Radio.displayName = 'Radio';

var FilterRadioGroup = function FilterRadioGroup(_ref) {
  var options = _ref.options,
      handleFilter = _ref.handleFilter,
      selectedOption = _ref.selectedOption,
      GA = _ref.GA,
      name = _ref.name,
      props = _objectWithoutPropertiesLoose(_ref, ["options", "handleFilter", "selectedOption", "GA", "name"]);

  return _react.default.createElement(_react.default.Fragment, null, options.map(function (option) {
    return _react.default.createElement(Option, _extends({
      key: option,
      selected: option === selectedOption
    }, props), _react.default.createElement(Radio, {
      "data-testid": "filter-buttons",
      onChange: function onChange() {
        handleFilter(option);
        (0, _reactGa.event)({
          action: GA.action,
          category: GA.category,
          label: option
        });
      },
      type: "radio",
      name: "filters"
    }), option);
  }));
};

FilterRadioGroup.propTypes = {
  options: (0, _propTypes.arrayOf)(_propTypes.string).isRequired,
  handleFilter: _propTypes.func.isRequired,
  name: _propTypes.string.isRequired,
  selectedOption: _propTypes.string,
  GA: (0, _propTypes.shape)({
    category: _propTypes.string,
    action: _propTypes.string
  }).isRequired
};
FilterRadioGroup.defaultProps = {
  selectedOption: undefined
};
var _default = FilterRadioGroup;
exports.default = _default;